import React, { useState } from 'react';
import { PractitionerPicker } from '../../CustomControls/PractitionerPicker';
import { Button, Col, ControlLabel, FormGroup, Grid, Modal, Row } from 'react-bootstrap';
import { useTranslation } from "react-i18next";
import { CustomSelect } from '../../CustomControls/CustomSelect';
import { Add, Save } from '../../Icons/Icons';
import { ModalData } from '../../Modals/ModalData';
import { CustomSearchBox } from '../../CustomControls/CustomSearchBox';

const AddPractitioners = ({ confirmPractitioners, addPractitioners, selectedPractitioners }) => {
    const { t } = useTranslation();
    const [isShowing, setIsShowing] = useState(false);

    return (
        <>
            <div className="col-md-3">
                <button type="button" className="btn btn-primary" onClick={() => { setIsShowing(true) }} ><Add />{t("buttons.add")}</button >
            </div>
            <ModalData
                isShowing={isShowing}
                hide={() => setIsShowing(false)}
                title={t('protocols.groups.addPractitioner')}
                size="medium"
                className=""
                footer={
                    <>
                        <Button type="button" className="btn " onClick={() => setIsShowing(false)} >{t("buttons.cancel")}</Button>
                        <Button type="submit" className="btn btn-success btn-primary" onClick={confirmPractitioners}>
                            <Save />{t("buttons.save")}
                        </Button>
                    </>
                }
            >
                <div>
                    <FormGroup>
                        <ControlLabel>{t('protocols.groups.practitioners')}</ControlLabel>
                        <PractitionerPicker
                            id="practitioner"
                            name="practitioner"
                            autoFocus
                            multiple={true}
                            onlyDoctor={false}
                            excludeMonitors={true}
                            placeholder={t('protocols.groups.practitioner')}
                            onChange={addPractitioners}
                            selected={selectedPractitioners }
                        />
                    </FormGroup>
                </div>

            </ModalData>
        </>
        
    );
};

export default AddPractitioners;